import { render, staticRenderFns } from "./SuperAdminDashboard.vue?vue&type=template&id=2a4bdd22&scoped=true&"
import script from "./SuperAdminDashboard.vue?vue&type=script&lang=js&"
export * from "./SuperAdminDashboard.vue?vue&type=script&lang=js&"
import style0 from "./SuperAdminDashboard.vue?vue&type=style&index=0&id=2a4bdd22&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a4bdd22",
  null
  
)

export default component.exports